/**
 * Утилиты для анимаций
 */

/**
 * Анимация числа от 0 до целевого значения
 * @param {HTMLElement} element - Элемент с числом
 * @param {number} duration - Длительность анимации в мс
 * @param {Function} onComplete - Callback при завершении
 */
export function animateNumber(element, duration = 2000, onComplete = null) {
  if (!element) return

  const text = element.textContent.trim()
  const hasPercent = text.includes('%')
  const hasPlus = text.includes('+')
  const hasSlash = text.includes('/')

  let target = 0
  let suffix = ''

  if (hasSlash) {
    // Формат "4.9/5"
    const parts = text.split('/')
    target = parseFloat(parts[0])
    suffix = '/' + parts[1]
  } else {
    // Формат "487" или "93%"
    target = parseInt(text.replace(/\D/g, ''), 10)
    suffix = hasPercent ? '%' : hasPlus ? '+' : ''
  }

  let current = 0
  const stepTime = 20
  const totalSteps = duration / stepTime
  const stepValue = target / totalSteps

  const interval = setInterval(() => {
    current += stepValue
    if (current >= target) {
      current = target
      clearInterval(interval)
      if (onComplete) onComplete()
    }

    if (hasSlash) {
      element.textContent = current.toFixed(1) + suffix
    } else {
      element.textContent = Math.floor(current) + suffix
    }
  }, stepTime)
}

/**
 * Анимация появления элементов при скролле
 * @param {string} selector - Селектор элементов
 * @param {string} animationClass - Класс для анимации
 * @param {number} offset - Отступ от края экрана
 */
export function initScrollAnimation(selector, animationClass = 'fade-in', offset = 100) {
  const elements = document.querySelectorAll(selector)
  if (!elements.length) return

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add(animationClass)
          observer.unobserve(entry.target)
        }
      })
    },
    {
      threshold: 0.1,
      rootMargin: `${offset}px`,
    }
  )

  elements.forEach((element) => {
    observer.observe(element)
  })
}

/**
 * Debounce функция
 * @param {Function} func - Функция для debounce
 * @param {number} wait - Время ожидания в мс
 * @returns {Function} - Debounced функция
 */
export function debounce(func, wait = 300) {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

/**
 * Throttle функция
 * @param {Function} func - Функция для throttle
 * @param {number} limit - Лимит времени в мс
 * @returns {Function} - Throttled функция
 */
export function throttle(func, limit = 300) {
  let inThrottle
  return function executedFunction(...args) {
    if (!inThrottle) {
      func(...args)
      inThrottle = true
      setTimeout(() => (inThrottle = false), limit)
    }
  }
}




